<template>
    <div class="px-6 py-3">
        <!-- Show loading spinner when data is being fetched -->
        <div v-if="loading" class="flex justify-center items-center h-32">
            <div class="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-opacity-75"></div>
            <p class="ml-3 text-gray-600">Fetching account details...</p>
        </div>

        <!-- Show table only when data is loaded -->
        <table v-else class="w-full border-collapse">
            <thead>
                <tr class="bg-gray-200 text-gray-800">
                    <th class="p-3 rounded-tl-lg">Account Name</th>
                    <th class="p-3">Account No</th>
                    <th class="p-3">Balance</th>
                    <th class="p-3 rounded-tr-lg"></th>
                </tr>
            </thead>
            <tbody v-if="accounts.length">
                <tr v-for="(account, index) in accounts" :key="index" class="bg-white shadow-md rounded-lg">
                    <td class="p-3">{{ account.account_name }}</td>
                    <td class="p-3">{{ account.cbsac }}</td>
                    <td class="p-3">₹{{ account.balance }}</td>
                    <td class="p-3">
                        <button
                            @click="requestBankStatement(account)"
                            :disabled="loadingAccount === account.khate"
                            class="px-6 py-2 text-white text-sm font-medium rounded-md"
                            :class="loadingAccount === account.khate ? 'bg-gray-400 cursor-not-allowed' : 'bg-primary hover:bg-blue-700'"
                        >
                            <span v-if="loadingAccount === account.khate">Processing...</span>
                            <span v-else>Bank Statement</span>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5" class="p-4 text-center text-gray-500">No accounts data available</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { apiRequest } from "@/api";

export default {
    name: 'BankAccounts',
    data() {
        return {
            accounts: [],
            loading: false, // Track if data is being fetched
            loadingAccount: null, // Track which bank statement is being processed
        };
    },
    props: {
        user: Object
    },
    created() {
        this.fetchAccounts();
    },
    methods: {
        async fetchAccounts() {
            this.loading = true; 

            try {
                const response = await apiRequest('/balance', 'GET');

                if (response.data.status === 'success') {
                    this.accounts = response.data.balances;
                }
            } catch (error) {
                console.error("Error fetching bank accounts:", error);
            } finally {
                this.loading = false;
            }
        },
        async requestBankStatement(account) {
            if (this.loadingAccount) return;
            this.loadingAccount = account.khate;

            let type = '';

            if (account.account_name === 'Saving Bank A/C' || account.account_name === 'Mayura Savings Acount') {
                type = "SB";
            } else if (account.account_name === 'Dividend Payable (A )' || account.account_name === 'Member Share Capital') {
                type = 'SH';
            } else if (account.account_name === 'Current Account') {
                type = 'CA';
            } else if (account.account_name === 'My Money Deposit') {
                type = 'PD';
            } else if (account.account_name === 'Samruddhi Cash Certificate') {
                type = 'CC';
            }

            try {
                const response = await apiRequest('/statements', 'POST', {
                    account: this.user.acno,
                    certno: 0,
                    sub_type: account.account_type,
                    type: type,
                    khate: account.khate
                });

                if (response.data.status === 'success') {
                    sessionStorage.setItem('bankStatement', JSON.stringify(response.data));
                    sessionStorage.setItem('statementSource', 'account');
                    this.$router.push('/bankStatement');
                }
            } catch (error) {
                console.error("Error fetching bank statements:", error);
            } finally {
                this.loadingAccount = null;
            }
        }
    }
};
</script>

<style scoped>
/* Add animation for loading spinner */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.animate-spin {
    animation: spin 1s linear infinite;
}
</style>
